import fixture from './CompanyCheckToken.get.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ICompanyCheckTokenClient,
} from 'interfaceAdapter/gatewaySchemas/ICompanyCheckTokenClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class CompanyCheckTokenClient implements ICompanyCheckTokenClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, addLoginCount, mock = false } = input;
        const PATH = `${API_LOCATION_URL}/company/user/check_token?login_count=${addLoginCount}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-C': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                  });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
